import type { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './ProjectEntityLayout.module.css';

export function Content({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={clsx(styles.contentContainer, className)}>{children}</div>;
}

export function ContentBlock({
  className,
  flush,
  children,
}: {
  className?: string;
  flush?: boolean;
  children: ReactNode;
}) {
  return <div className={clsx(flush ? styles.contentBlockFlush : styles.contentBlock, className)}>{children}</div>;
}
